import { Col, Flex, Form, Input, Radio, Row, Select, Table, Tag } from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../../common/spinner/Spinner";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import { colors } from "../../../../../../constants/colors";
import { SearchOutlined } from "@ant-design/icons";
import {
  getServiceProvidersAction,
  updateServiceProviderStatusAction,
} from "../../../../../../redux/services/service-providers/serviceProvidersServices";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import useDebounce from "../../../../../../hooks/useDebounce";
import { getSuperAdminServicesAction } from "../../../../../../redux/services/super-admin-services/superAdminServicesServices";
import styles from "./Services.module.scss";

const Services = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { superAdminServices } = useSelector(
    (state) => state.superAdminServices
  );
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: superAdminServices?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* filter dependencies */
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  /* filter dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    setLoading(true);
    const dataToBeSent = {
      page: pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue,
    };
    dispatch(getSuperAdminServicesAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  /* on status changed */
  const onStatusChanged = (id, value, record) => {
    const dataToBeSent = {};
    dataToBeSent.selectedServiceProviderId = record?._id;
    dataToBeSent["status"] = value?.value;

    dispatch(updateServiceProviderStatusAction(dataToBeSent)).then(() => {
      handleGetTableData();
    });
  };
  /* on status changed */

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: "Date of Joining",
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.created_at, "ddmmyyyy")}</p>
        ),
      },
      {
        title: "Service Provider",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "City",
        dataIndex: "address",
        key: "address",
        render: (address) => `${address?.city?.name || "-"}`,
      },
      {
        title: "Status",
        key: "action",
        align: "center",
        render: (_, record) => {
          const getColorBasedOnStatus = (status) => {
            switch (status) {
              case "active":
                return { background: colors.lightTeal, color: colors.darkTeal };

              case "inactive":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              case "suspended":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              case "deleted":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              default:
                break;
            }
          };
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  ...getColorBasedOnStatus(record?.status),
                  textTransform: "capitalize",
                }}
              >
                {record?.status}
              </Tag>
            </>
          );
        },
      },
      {
        title: "Action",
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Select
                options={[
                  { value: "active", label: t("CommonUtils.active") },
                  { value: "inactive", label: t("CommonUtils.inactive")},
                  { value: "suspended", label: t("CommonUtils.suspended")},
                  { value: "deleted", label: t("CommonUtils.delete")},
                ]}
                placeholder="Select Status"
                defaultValue={record?.status}
                style={{ width: 120 }}
                onChange={(id, value) => onStatusChanged(id, value, record)}
              />
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    // <div className={styles.userContainer}>
    //   <Flex vertical gap="2rem">
    //   <Row gutter={[24]}>
    //         <Col span={7} style={{ display: "flex", alignItems: "end" }}>
    //             <Input
    //               size="large"
    //               suffix={<SearchOutlined />}
    //               placeholder="Search"
    //               onChange={(event) => setSearchValue(event.target.value)}
    //             />
    //         </Col>
    //       </Row>
    //     {loading || debounceLoading ? (
    //       <Spinner />
    //     ) : (
    //       <Table
    //         dataSource={superAdminServices?.data}
    //         columns={columns}
    //         pagination={paginationObj}
    //       />
    //     )}
    //   </Flex>
    // </div>
    <></>
  );
};

export default Services;
